import { NodeType } from "@/app/chatbots/utils/enums";

export const DeleteTextByNode = {
  [NodeType.Message]: "¿Estás segur@ de eliminar este mensaje?",
  [NodeType.Options]: "¿Estás segur@ de eliminar esta acción de opciones múltiples?",
  [NodeType.Option]: "",
  [NodeType.Buttons]: "¿Estás segur@ de eliminar la acción de Botones?",
  [NodeType.ButtonOption]: "¿Estás segur@ de eliminar este botón?",
  [NodeType.List]: "¿Estás segur@ de eliminar esta lista?",
  [NodeType.ListSection]: "¿Estás segur@ de eliminar esta sección?",
  [NodeType.ListSectionItem]: "¿Estás segur@ de eliminar este Ítem?",
  [NodeType.Card]: "¿Estás segur@ de eliminar esta tarjeta con botones?",
  [NodeType.CardSection]: "¿Estás segur@ de eliminar esta tarjeta?",
  [NodeType.MessageWithImage]: "¿Estás segur@ de eliminar este mensaje?",
  [NodeType.MessageWithDocument]: "¿Estás segur@ de eliminar este mensaje?",
  [NodeType.MessageWithVideo]: "¿Estás segur@ de eliminar este mensaje?",
};

export const AcronymByNode = {
  [NodeType.Message]: "M",
  [NodeType.Options]: "OM",
  [NodeType.Option]: "",
  [NodeType.Buttons]: "B",
  [NodeType.ButtonOption]: "",
  [NodeType.List]: "L",
  [NodeType.ListSection]: "",
  [NodeType.ListSectionItem]: "",
  [NodeType.Card]: "T",
  [NodeType.CardSection]: "",
  [NodeType.MessageWithImage]: "M",
  [NodeType.MessageWithDocument]: "M",
  [NodeType.MessageWithVideo]: "M",
  [NodeType.WrongOptionAPI]: "",
  [NodeType.OptionConsultApi]: "",
};

export const NodeTypeName = {
  [NodeType.Message]: "Mensaje",
  [NodeType.Options]: "Opciones Múltiples",
  [NodeType.Option]: "Opción",
  [NodeType.Buttons]: "Botón",
  [NodeType.ButtonOption]: "Opcíon",
  [NodeType.List]: "Lista",
  [NodeType.ListSection]: "Sección",
  [NodeType.ListSectionItem]: "Item",
  [NodeType.Card]: "Tarjeta",
  [NodeType.CardSection]: "Sección",
  [NodeType.MessageWithImage]: "Mensaje",
  [NodeType.MessageWithDocument]: "Mensaje",
  [NodeType.MessageWithVideo]: "Mensaje",
};
